import { type DomainAccessControlConfig } from 'domains/fulfillment-testing-center/utils/domain/accessControl'
import { Permission } from 'domains/fulfillment-testing-center/access-control/permissions'
import { Flipper } from 'domains/fulfillment-testing-center/access-control/flippers'

export const fulfillmentTestingCenterAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.DevPortal],
}

export const fulfillmentTestingCenterPickupBatchEnabled: DomainAccessControlConfig = {
  flippers: [Flipper.pickupBatching],
}
